import Modal from './Modal'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons'


function Certifications(props) {
    const [modal, setModal] = useState(false)
    const { refCertificates } = props.route

    const renderHashInfo = () => {

        let html =<ul className="list-unstyled p-2">
            {refCertificates && refCertificates.length > 0 && refCertificates.map((item) => {
                return  <li  className="media d-inline-flex w-100 bg-white customShadow customRadius mb-3 impactCriteria" key={item.id}>
                    <img className="my-3 materialImage impactImage mb-2 customRadius" src={item.refImage} alt={item?.name}  />
                    <div className="media-body">
                        <h5 className="mt-2 mb-1">{item?.name}</h5>
                        <p className="text-secondary">
                           <span dangerouslySetInnerHTML={{__html:item?.description}}></span>
                           {item.file && <a href={item.file} className='greenButton customRadius mt-2' >VIEW</a>}
                        </p>
                    </div>
                </li>
            })}
           
        </ul>

        return <div>
            {html}
           
        </div>
    }

    return <li className="beigeBox customShadow customRadius px-1 py-3 beigeBoxPointer">
            <div className="d-flex w-100 align-items-center justify-content-between" onClick={() => setModal(!modal)}>
                <div className='beigeBoxOnlyTitleWrap'>
                    
                    <h3>Certifications</h3>
                </div>
                <div className='beigeBoxOnlyIconWrap p-0'>
                    <FontAwesomeIcon icon={faFileAlt}  />
                </div>
            </div>
            
        {modal && <Modal title="Certifications" modal={modal} toggleModal={setModal}>{renderHashInfo()}</Modal>}
    </li>
}


export default Certifications